import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import './index.css';
import {CartProvider} from "./v3/context/cart";
import AppVersion4 from "./v4";
import LinkTreePage from "./v3/pages/linktree/link-tree";

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <CartProvider>
            <RouterProvider router={router} />
            {/*<AppVersion4 />*/}
        </CartProvider>
    </React.StrictMode>
);